import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=853764c4&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('853764c4')) {
      api.createRecord('853764c4', component.options)
    } else {
      api.reload('853764c4', component.options)
    }
    module.hot.accept("./folder.vue?vue&type=template&id=853764c4&", function () {
      api.rerender('853764c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/folder.vue"
export default component.exports